const init = (filterClassPattern, clearOnTargetSelect = false) => {
    const body = document.querySelector("body");
    const filters = body.querySelectorAll(".form__filters");
    const filterEvent = new Event("filterSelectMenu");

    const filterSetClasses = {};

    filters.forEach(filterSet => {
        const filterSetName = filterSet.dataset.filterSet;
        const filterButtons = filterSet.querySelectorAll("button");
        filterSetClasses[filterSetName] = [];

        // Add filter classes for this set to filterSetClasses object - used to manage classes on the body element
        filterButtons.forEach(filterButton => {
            const filterClass = filterButton.className.match(filterClassPattern);
            if (Array.isArray(filterClass)) {
                filterSetClasses[filterSetName].push(filterButton.className.match(filterClassPattern)[0]);
            }
        });

        // A filterSet is the output of the list_filter component
        filterSet.addEventListener("click", (e) => {
            if (e.target.tagName.toLowerCase() === "button") {
                setFilter(e);
            }
        });
        filterSet.addEventListener("keydown", keydownHandler);
        return false;
    });

     if (clearOnTargetSelect) {
        window.addEventListener("targetSelected", (e) => {
            const activeFilter = e.detail.filterClass;
            // Reset the filters for the filter set containing the provided class
            for (let [filterSetName, filterSetArray] of Object.entries(filterSetClasses)) {
                if (filterSetArray.includes(activeFilter)) {
                    const filterFieldset = body.querySelector(`#${filterSetName}`);
                    if (filterFieldset) {
                        const showClass = `filter--all-${filterSetName}`;
                        applyFilter(filterSetName, filterFieldset, showClass);
                    }
                    return;
                }
            }
        });
    }

    function keydownHandler(e) {
        if (e.key === "Enter" && e.target.tagName.toLowerCase() === "button") {
            setFilter(e);
        }
    }

    function setFilter(e) {
        const filterFieldset = e.target.closest("fieldset");
        const filterSuffix = e.target.value;
        const showClass = `filter--${filterSuffix}`;

        applyFilter(e.target.dataset.filterSet, filterFieldset, showClass, filterSuffix);
    }

    function applyFilter(filterSetName, filterFieldset, showClass, value = false) {
        const filterClasses = filterSetClasses[filterSetName];
        body.classList.remove(...filterClasses);
        body.classList.add(showClass);

        if (value) {
            const valueField = filterFieldset.querySelector(".filter__hidden");
            if (valueField) {
                valueField.value = value;
            }
        }

        const filterInputs = filterFieldset.querySelectorAll("button.filter");
        filterInputs.forEach(filter => {
            filter.ariaChecked = filter.classList.contains(showClass) === true;
        });

        window.dispatchEvent(filterEvent);
    }
}

export const listFilter = {
    init: init
}